import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "@/pages/Portfolio";
import CaseStudy from "@/pages/CaseStudy";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import RouteScrollReset from "@/components/RouteScrollReset";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  return (
    <div className="App">
      <a
        href="#top"
        data-testid="skip-to-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-black focus:text-white focus:px-4 focus:py-2 focus:rounded-full focus:text-sm"
      >
        Skip to content
      </a>
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <RouteScrollReset />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/projects/:slug" element={<CaseStudy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ScrollToTop />
        <WhatsAppButton />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
